import React, { useState } from "react";

import {
  VStack,
  Flex,
  Text,
  Input,
  Button,
  IconButton,
  Box,
  Stack,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react';

import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

import { axiosPublic } from "../../helpers/Axios";

import getText from '../../helpers/dictionary/getText';
import { Formik ,Form, Field } from "formik";

import IsEmail from 'isemail';


export const LoginForm = (props) => {

  const [loading, setLoading] = useState(false)

  const [show, setShow] = useState(false);
  const handleShowClick = () => setShow(!show);

  const [errorForm, setErrorForm] = useState('');


  const validateEmail = (value) => {
    if (!value) {
      return getText("errorRequiredField");
    }
    if (!IsEmail.validate(value)) {
      return getText("errorInvalidMail");
    }
    return '';
  }

  const validatePassword = (value) => {
    if (!value) {
      return getText("errorRequiredField");
    }
    return '';
  }

  const sendLogin = async (value) => {
    setErrorForm('');
    setLoading(true);

    axiosPublic.post('/users/login', {
      email: value.email,
      password: value.password
    })
    .then(result => {
      location.replace('/public');
    })
    .catch(error => {
      if (!error.response) {
        setErrorForm(getText("serverError"));
        return;
      }
      setErrorForm(getText(error.response.data.traduction));
    })
    .finally(() => {
      setLoading(false);
    })
  }

  return (
    <Box width="45%" mx="15%" mt="15px">
      <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        onSubmit={(values) => {
          sendLogin(values);
        }}
      >
        {(props) => (
          <Form>
            <Stack
              bgColor="blue.600"
              borderRadius="50px"
              padding="10"
              spacing="4"
            >
              <VStack style={{ alignItems: "start"}} >
                <Text as="b" color="white" fontSize="3xl">
                  {getText("loginTitle")}
                </Text>
                <Field name="email" validate={validateEmail}>
                  {({ field, form }) => (
                    <FormControl isInvalid={form.errors.email && form.touched.email} isRequired>
                      <FormLabel color="white" htmlFor="email">{getText("formEmailTitle")}</FormLabel>
                      <Input
                        {...field}
                        isDisabled={loading ? true : false}
                        bgColor="white"
                        textColor="bleu.800"
                        colorScheme="white"
                        placeholder={getText("formEmailPlaceholder")}
                        size="lg"
                        textStyle="bold"
                        id="email"
                      />
                      <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="password" validate={validatePassword}>
                  {({ field, form }) => (
                    <FormControl isInvalid={form.errors.password && form.touched.password} isRequired>
                      <FormLabel color="white" htmlFor="password">{getText("formPasswordTitle")}</FormLabel>
                      <Flex>
                        <Input
                          {...field}
                          isDisabled={loading ? true : false}
                          bgColor="white"
                          textColor="bleu.800"
                          colorScheme="white"
                          placeholder={getText("formPasswordPlaceholder")}
                          size="lg"
                          textStyle="bold"
                          id="password"
                          type={show ? 'text' : 'password'}
                        />
                        <IconButton ml={2} size='lg' onClick={handleShowClick}
                          icon={show ? <ViewOffIcon/> : <ViewIcon/> }
                        />
                      </Flex>
                      <FormErrorMessage>{form.errors.password}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </VStack>
              <VStack pt={2} width="100%" style={{ alignItems: "end"}}>
                <Button isLoading={loading ? true : false} size="lg" type="submit" textColor="blue.800">
                  {getText("buttonSend")}
                </Button>
              </VStack>
              {errorForm &&
              <Alert status='error' borderRadius="md">
                <AlertIcon />
                <AlertDescription>{errorForm}</AlertDescription>
              </Alert>}
            </Stack>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
